var _path, _path2, _g, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGoldClock = function SvgGoldClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9984 67.9967C15.2065 67.9967 0 52.6944 0 34.0601C0 15.4258 15.2065 0 33.9984 0C52.7902 0 67.9967 15.3023 67.9967 33.9367C67.9967 52.571 52.6665 67.9967 33.9984 67.9967Z",
    fill: "#FFE315"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1098 6.6882C49.1583 6.6882 61.42 18.9499 61.42 33.9984C61.42 49.0468 49.1583 61.3085 34.1098 61.3085C19.0614 61.3085 6.79967 49.0468 6.79967 33.9984C6.79967 18.9499 18.9499 6.6882 34.1098 6.6882ZM34.1098 0C15.2714 0 0 15.2714 0 33.9984C0 52.7253 15.2714 67.9967 33.9984 67.9967C52.7253 67.9967 67.9967 52.7253 67.9967 33.9984C67.9967 15.2714 52.8368 0 34.1098 0Z",
    fill: "#FFAE00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0574 0V68.0274C52.8647 68.0274 67.9997 52.7742 67.9997 34.0694C67.9997 15.2533 52.7535 0 34.0574 0Z",
    fill: "#FF8200"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.563 36.2547H34.3993V17.2971",
    stroke: "#002C3B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoldClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/goldClock.0c867a83.svg";
export { ForwardRef as ReactComponent };